// @flow
import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { DrapItemContext } from './DrapItemContext';
import QuoteList from './DropList';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default function DragDropContainer(props) {
  // dynamicFormAttr：动态表单列，fields：动态表单行
  const { dynamicFormAttr, fields, removeFn, quotes, onDrapChange } = props;

  // demoData
  // const [quotes, setQuotes] = useState<any>([
  //   {
  //     id: 'G15162',
  //     content: 'Is that where creativity comes from? From sad biz?',
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15163',
  //     content: 'Sucking at something is the first step towards being sorta good at something.',
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15164',
  //     content: 'Sucking at something is the first step towards being sorta good at something.',
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15165',
  //     content: 'Responsibility demands sacrifice',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15166',
  //     content: 'Sometimes life is scary and dark',
  //     author: {
  //       id: '2',
  //       name: 'BMO',
  //       url: 'http://adventuretime.wikia.com/wiki/BMO',
  //       avatarUrl: 'static/media/bmo-min.9c65ecdf.png',
  //       colors: { soft: '#E3FCEF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15167',
  //     content: "Haven't slept for a solid 83 hours, but, yeah, I'm good.",
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15168',
  //     content: 'Please! I need the real you!',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15169',
  //     content: 'I should not have drunk that much tea!',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15170',
  //     content: "You got to focus on what's real, man",
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15171',
  //     content: "Haven't slept for a solid 83 hours, but, yeah, I'm good.",
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15172',
  //     content: "Don't you always call sweatpants 'give up on life pants,' Jake?",
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15173',
  //     content: 'Homies help homies. Always',
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15174',
  //     content:
  //       "People make mistakes. It's all a part of growing up and you never really stop growing",
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15175',
  //     content: "Haven't slept for a solid 83 hours, but, yeah, I'm good.",
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15176',
  //     content: 'Sometimes life is scary and dark',
  //     author: {
  //       id: '2',
  //       name: 'BMO',
  //       url: 'http://adventuretime.wikia.com/wiki/BMO',
  //       avatarUrl: 'static/media/bmo-min.9c65ecdf.png',
  //       colors: { soft: '#E3FCEF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15177',
  //     content: "That's it! The answer was so simple, I was too smart to see it!",
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15178',
  //     content: 'I should not have drunk that much tea!',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15179',
  //     content: 'Sometimes life is scary and dark',
  //     author: {
  //       id: '2',
  //       name: 'BMO',
  //       url: 'http://adventuretime.wikia.com/wiki/BMO',
  //       avatarUrl: 'static/media/bmo-min.9c65ecdf.png',
  //       colors: { soft: '#E3FCEF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15180',
  //     content: 'Responsibility demands sacrifice',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15181',
  //     content: "That's it! The answer was so simple, I was too smart to see it!",
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15182',
  //     content: 'Is that where creativity comes from? From sad biz?',
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15183',
  //     content: "You got to focus on what's real, man",
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15184',
  //     content: 'Is that where creativity comes from? From sad biz?',
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15185',
  //     content: 'Please! I need the real you!',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15186',
  //     content: 'I should not have drunk that much tea!',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15187',
  //     content: 'Is that where creativity comes from? From sad biz?',
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15188',
  //     content: "Don't you always call sweatpants 'give up on life pants,' Jake?",
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15189',
  //     content: "Haven't slept for a solid 83 hours, but, yeah, I'm good.",
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15190',
  //     content: 'Responsibility demands sacrifice',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15191',
  //     content: 'Sucking at something is the first step towards being sorta good at something.',
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15192',
  //     content: 'Sucking at something is the first step towards being sorta good at something.',
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15193',
  //     content: 'Sucking at something is the first step towards being sorta good at something.',
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15194',
  //     content: "Don't you always call sweatpants 'give up on life pants,' Jake?",
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15195',
  //     content:
  //       "People make mistakes. It's all a part of growing up and you never really stop growing",
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15196',
  //     content: 'Is that where creativity comes from? From sad biz?',
  //     author: {
  //       id: '3',
  //       name: 'Finn',
  //       url: 'http://adventuretime.wikia.com/wiki/Finn',
  //       avatarUrl: 'static/media/finn-min.0a5700c4.png',
  //       colors: { soft: '#DEEBFF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15197',
  //     content: 'Sometimes life is scary and dark',
  //     author: {
  //       id: '2',
  //       name: 'BMO',
  //       url: 'http://adventuretime.wikia.com/wiki/BMO',
  //       avatarUrl: 'static/media/bmo-min.9c65ecdf.png',
  //       colors: { soft: '#E3FCEF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15198',
  //     content: 'Sometimes life is scary and dark',
  //     author: {
  //       id: '2',
  //       name: 'BMO',
  //       url: 'http://adventuretime.wikia.com/wiki/BMO',
  //       avatarUrl: 'static/media/bmo-min.9c65ecdf.png',
  //       colors: { soft: '#E3FCEF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15199',
  //     content: "You got to focus on what's real, man",
  //     author: {
  //       id: '1',
  //       name: 'Jake',
  //       url: 'http://adventuretime.wikia.com/wiki/Jake',
  //       avatarUrl: 'static/media/jake-min.cc34aede.png',
  //       colors: { soft: '#FFFAE6', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15200',
  //     content: 'I should not have drunk that much tea!',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  //   {
  //     id: 'G15201',
  //     content: 'Responsibility demands sacrifice',
  //     author: {
  //       id: '4',
  //       name: 'Princess bubblegum',
  //       url: 'http://adventuretime.wikia.com/wiki/Princess_Bubblegum',
  //       avatarUrl: 'static/media/princess-min.34218e29.png',
  //       colors: { soft: '#EAE6FF', hard: 'rgba(9, 30, 66, 0.71)' },
  //     },
  //   },
  // ]);

  function onDragStart() {
    // Add a little vibration if the browser supports it.
    // Add's a nice little physical feedback
    if (window.navigator.vibrate) {
      window.navigator.vibrate(100);
    }
  }

  function onDragEnd(result) {
    // combining item
    if (result.combine) {
      // super simple: just removing the dragging item

      const newQuotes = [...quotes];
      newQuotes.splice(result.source.index, 1);
      // setQuotes(newQuotes);
      if (typeof onDrapChange === 'function') {
        onDrapChange(newQuotes);
      }
      return;
    }

    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const newQuotes = reorder(quotes, result.source.index, result.destination.index);
    // setQuotes(newQuotes);
    if (typeof onDrapChange === 'function') {
      onDrapChange(newQuotes);
    }
  }

  return (
    <DrapItemContext.Provider value={{ dynamicFormAttr, fields, removeFn, quotes }}>
      <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
        <QuoteList
          listId="list"
          style={props.listStyle}
          // quotes={quotes}
          isCombineEnabled={props.isCombineEnabled}
        />
      </DragDropContext>
    </DrapItemContext.Provider>
  );
}
